import api from '@/services/api/api'

class FilterService {
  getAll (filter) {
    return api.get('filter', {
      params: {
        collectionId: filter.collectionId,
        authors: filter.authors,
        themes: filter.themes,
        styles: filter.styles,
        techniques: filter.techniques,
        materials: filter.materials,
        datingYearFrom: filter.datingYearFrom === '' ? null : filter.datingYearFrom,
        datingYearTo: filter.datingYearTo === '' ? null : filter.datingYearTo,
        acquisitionYearFrom: filter.acquisitionYearFrom === '' ? null : filter.acquisitionYearFrom,
        acquisitionYearTo: filter.acquisitionYearTo === '' ? null : filter.acquisitionYearTo,
        artworkTypeId: filter.artworkTypeId === '' ? null : filter.artworkTypeId,
        evidenceNumber: filter.evidenceNumber === '' ? null : filter.evidenceNumber,
        name: filter.name === '' ? null : filter.name
      } }).then(result => {
      return result.data
    })
  }
  queryCurrentArtwork (artworkId, filter) {
    return api.post('filter/query-current-artwork-by-filter', {
      artworkId: artworkId,
      filter: filter
    }).then(result => {
      return result.data
    })
  }
  queryPreviousArtwork (artworkId, filter) {
    return api.post('filter/query-previous-artwork-by-filter', {
      artworkId: artworkId,
      filter: filter
    }).then(result => {
      return result.data
    })
  }
  queryNextArtwork (artworkId, filter) {
    return api.post('filter/query-next-artwork-by-filter', {
      artworkId: artworkId,
      filter: filter
    }).then(result => {
      return result.data
    })
  }
}

export default new FilterService()



// WEBPACK FOOTER //
// ./src/services/artwork/FilterService.js